import { createSelector } from 'reselect';
import { isTestTargetReadySelector } from 'viewModel/selectors/testTarget/isTestTargetReadySelector';
import { showSelector } from 'selectors/testTarget/offers/addPercentOffFlagToSalePage/show/showSelector';

const showAddPercentOffFlagToSalePageSelector = createSelector(isTestTargetReadySelector, showSelector, (testReady, show) => {
    return testReady && show;
});

export { showAddPercentOffFlagToSalePageSelector };
